/**
 * @file コンポーネント：お知らせリスト ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// 関数読み込み
import {
    fnGetDepartmentCode,
    fnHandleApiErrors,
    fnHandleApiSuccess,
} from "~/src/functions/common";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Newslist = () => {
    // お知らせリスト取得
    const [limit, setLimit] = useState(10);
    const [list, setList] = useState([]);
    const [hasNext, setHasNext] = useState(false);
    const departmentCode =
        fnGetDepartmentCode() !== null ? fnGetDepartmentCode() : 1;
    const offset = 0;
    useEffect(() => {
        const api =
            "/api/news/" +
            departmentCode +
            "?offset=" +
            offset +
            "&limit=" +
            limit;
        fetch(api)
            .then(fnHandleApiErrors)
            .then(fnHandleApiSuccess)
            .then((result) => {
                if (result !== null) {
                    const newslist = result.newsList.map((item) => {
                        const date = new Date(item.startedAt);
                        const year = ("0" + date.getFullYear()).slice(-4);
                        const month = ("0" + (date.getMonth() + 1)).slice(-2);
                        const day = ("0" + date.getDate()).slice(-2);
                        const dateString = year + "/" + month + "/" + day;
                        return {
                            date: dateString,
                            dateTime: item.startedAt,
                            target:
                                item.url.indexOf(location.hostname) === -1 ||
                                item.url.indexOf("http://") === -1 ||
                                item.url.indexOf("https://") === -1
                                    ? "_blank"
                                    : "",
                            title: item.title,
                            url: item.url,
                        };
                    });
                    setList(newslist);
                    setHasNext(result.hasNext);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [limit]);

    // Presenterに渡す
    return (
        <Presenter
            hasNext={hasNext}
            limit={limit}
            list={list}
            setLimit={setLimit}
        />
    );
};
